var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(!_vm.loaded)?_c('div',{attrs:{"id":"async-script-loading"}}):_vm._e(),(_vm.loaded && !_vm.err)?_vm._t("default"):_vm._e(),(_vm.err)?_c('div',[_vm._v("oops, something wrong")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }